import React from 'react';
import {
  Box,
  makeStyles,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from '@material-ui/core';

import Divider from '../Divider';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    border: '1px solid',
    borderColor: theme.palette.secondary.main,
    borderRadius: 5,
    padding: '10px',
    [theme.breakpoints.up('sm')]: {
      padding: '40px',
    },
  },
}));

export default function TermsBox({
  title,
  children,
  setAcceptTerms,
  acceptTerms,
}) {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Box fontWeight='fontWeightBold' fontSize={16}>
        {title}
      </Box>
      <Divider height={3} mt='8px' mb='16px' />
      {children}
      <Divider height={3} mb='8px' mt='16px' />
      <Box display='flex' justifyContent='flex-end' mt='8px'>
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                checked={acceptTerms}
                onChange={() => setAcceptTerms(!acceptTerms)}
                name='checked'
                color='primary'
              />
            }
            labelPlacement='start'
            label='Acepto Términos y Condiciones'
          />
        </FormGroup>
      </Box>
    </Box>
  );
}
